var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "p-3" },
    [
      _c("h3", [_vm._v("Detail Berkas Pasien")]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c(
        "router-link",
        {
          staticClass: "btn btn-sm btn-danger",
          attrs: { to: `/pasien-tidak-aktif-5-tahun/${_vm.Medrec}` },
        },
        [_vm._v("Kembali")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-sm btn-primary",
          on: { click: _vm.scanNewDocs },
        },
        [_vm._v("Scan Berkas")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row mt-3" }, [
        _c("div", { staticClass: "col-md-6" }, [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-header text-white bg-primary" }, [
              _vm._v(
                "\n                    Daftar Berkas Pasien\n                "
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card-body" },
              _vm._l(_vm.berkas_pasien, function (bp, idx) {
                return _c("table", { key: idx, staticClass: "table mb-3" }, [
                  _c("tbody", [
                    _c("tr", [
                      _c("td", { attrs: { width: "5%" } }, [
                        _vm._v(_vm._s(idx + 1)),
                      ]),
                      _vm._v(" "),
                      _c("td", { attrs: { width: "20%" } }, [_vm._v("Judul")]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(bp.doc_title))]),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", { attrs: { width: "5%" } }),
                      _vm._v(" "),
                      _c("td", { attrs: { width: "20%" } }, [
                        _vm._v("Deskripsi"),
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(bp.doc_description))]),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", { attrs: { width: "5%" } }),
                      _vm._v(" "),
                      _c("td", { attrs: { width: "20%" } }, [
                        _vm._v("Dibuat Oleh"),
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(bp.created_by))]),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", { attrs: { width: "5%" } }),
                      _vm._v(" "),
                      _c("td", { attrs: { width: "20%" } }, [
                        _vm._v("Tanggal"),
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(bp.created_at))]),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", { attrs: { width: "5%" } }),
                      _vm._v(" "),
                      _c("td", { attrs: { width: "20%" } }, [
                        _vm._v("Dokumen Pasien"),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-sm btn-primary",
                            on: {
                              click: function ($event) {
                                return _vm.previewBerkas(bp)
                              },
                            },
                          },
                          [_vm._v("Lihat")]
                        ),
                      ]),
                    ]),
                  ]),
                ])
              }),
              0
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6" }, [
          _vm.scan_new
            ? _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col" }, [
                  _c("div", { staticClass: "card" }, [
                    _c(
                      "div",
                      { staticClass: "card-header text-white bg-primary" },
                      [
                        _vm._v(
                          "\n                            Scan Berkas Baru\n                        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "card-body" }, [
                      _c("div", { staticClass: "row mb-1" }, [
                        _c(
                          "label",
                          {
                            staticClass: "col-md-4",
                            attrs: { for: "judul-berkas" },
                          },
                          [_vm._v("Judul")]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-8" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.scan_baru.judul_berkas,
                                expression: "scan_baru.judul_berkas",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: { type: "text", id: "judul-berkas" },
                            domProps: { value: _vm.scan_baru.judul_berkas },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.scan_baru,
                                  "judul_berkas",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row mb-1" }, [
                        _c(
                          "label",
                          {
                            staticClass: "col-md-4",
                            attrs: { for: "tanggal-berkas" },
                          },
                          [_vm._v("Tanggal")]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-8" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.scan_baru.tanggal_berkas,
                                expression: "scan_baru.tanggal_berkas",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: { type: "date", id: "tanggal-berkas" },
                            domProps: { value: _vm.scan_baru.tanggal_berkas },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.scan_baru,
                                  "tanggal_berkas",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row mb-1" }, [
                        _c(
                          "label",
                          {
                            staticClass: "col-md-4",
                            attrs: { for: "deskripsi" },
                          },
                          [_vm._v("Deskripsi")]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-8" }, [
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.scan_baru.deskripsi,
                                expression: "scan_baru.deskripsi",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: { id: "scan_baru.deskripsi" },
                            domProps: { value: _vm.scan_baru.deskripsi },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.scan_baru,
                                  "deskripsi",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "label",
                          {
                            staticClass: "col-md-4",
                            attrs: { for: "list-image" },
                          },
                          [_vm._v("Daftar Dokumen")]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-8" }, [
                          _vm.scan_baru.doc_lists.length > 0
                            ? _c(
                                "ul",
                                _vm._l(
                                  _vm.scan_baru.doc_lists,
                                  function (dl, idx) {
                                    return _c("li", { key: idx }, [
                                      _vm._v(_vm._s(dl.filename)),
                                    ])
                                  }
                                ),
                                0
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.scan_baru.doc_lists.length == 0
                            ? _c("p", [_vm._v("Belum ada dokumen")])
                            : _vm._e(),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row mb" }, [
                        _c("div", { staticClass: "col-md-4" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-8" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-sm btn-primary",
                              on: { click: _vm.scanBerkas },
                            },
                            [_vm._v("Scan")]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-sm btn-success",
                              on: { click: _vm.simpanBerkas },
                            },
                            [_vm._v("Simpan")]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-sm btn-danger",
                              on: {
                                click: function ($event) {
                                  _vm.scan_new = false
                                },
                              },
                            },
                            [_vm._v("Batal")]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "row mb-1 mt-3" },
                        _vm._l(_vm.scan_baru.doc_lists, function (sbdl, idx) {
                          return _c("img", {
                            key: idx,
                            staticStyle: { width: "100%" },
                            attrs: {
                              src: sbdl.preview_url,
                              alt: "Preview Image",
                            },
                          })
                        }),
                        0
                      ),
                    ]),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.preview_id
            ? _c(
                "div",
                [
                  _c("h4", [_vm._v(_vm._s(_vm.berkas_title))]),
                  _vm._v(" "),
                  _vm.berkas_image.length > 0
                    ? [
                        _vm._l(_vm.berkas_image, function (b, idx) {
                          return _c("img", {
                            key: idx,
                            staticStyle: { width: "100%" },
                            attrs: {
                              src: `/${b.file_name}`,
                              alt: "Preview Image",
                            },
                          })
                        }),
                        _vm._v(">\n                "),
                      ]
                    : _vm._e(),
                ],
                2
              )
            : _vm._e(),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }